<div class="sustainability-future">
  <div class="future-plan-1">
    <div class="future-date col-sm-2">
      <div class="panel panel-default">
        <div class="panel-heading"></div>
        <div class="panel-body">
          <p>2023</p>
          <p>May</p>
        </div>
      </div>
    </div>
  
    <div class="future-img col-sm-4">
        <img class="future-content" src="assets/images/Background/solar-panel.jpg">
    </div>
  
    <div class="future-plan col-sm-6">
      <h2>Solar System</h2><br>
      <p>This new approach is introduced in Seng Hin Rubber for energy emission reduction. 
        Estimated total electricity powered by the solar would be ~30% 
        from the total usage.
      </p>
    </div>
  
    <div class="border-bottom"></div>
  </div>

  <div class="future-plan-2">
    <div class="future-date col-sm-2">
      <div class="panel panel-default">
        <div class="panel-heading"></div>
        <div class="panel-body">
          <p>2023</p>
          <p>OCT</p>
        </div>
      </div>
    </div>

    <div class="future-img col-sm-4">
      <img class="future-content" src="assets/images/machine.jpg">
    </div>

    <div class="future-plan col-sm-6">
      <h2>Robotic Process Automation (RPA)</h2><br>
      <p>We plan to accelerate our production rate by first implementing the robotic in certain process of 
        rubber manufacturing. In the following phases, all of the manufacturing processes will be operated by the machines.
      </p>
    </div>

  </div>
</div>